<template>
	<AlertMessage type="warning">
		Showing the last {{ subject }} saved on this device. The refresh did not complete.
		<template #action>
			<v-btn
				variant="flat"
				color="primary"
				:loading="retrying"
				@click="$emit('retry')"
			>
				Reload
			</v-btn>
		</template>
	</AlertMessage>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AlertMessage from "@/components/Common/AlertMessage.vue";

export default defineComponent({
	name: "CachedListNotice",
	components: { AlertMessage },
	props: {
		// Reads mid-sentence: "the last completed tasks saved on this device".
		subject: { type: String, required: true },
		retrying: { type: Boolean, default: false },
	},
	emits: { retry: () => true },
});
</script>
